import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { Text } from "@sundae/ui-toolkit";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button.js";
const NotFound = () => {
    const { t } = useI18N("not-found");
    const navigate = useNavigate();
    return (_jsxs("div", { className: "flex flex-col items-center justify-center gap-10", style: {
            minHeight: `calc(100vh - 100px)`,
        }, children: [_jsx(Text, { tag: "h2", size: "7xl", weight: "bold", children: t("notFound.context.404.title") }), _jsx(Text, { tag: "p", size: "xl", children: t("notFound.context.404.copy") }), _jsx(Button, { variant: "primary", onClick: () => {
                    navigate("/");
                }, children: t("notFound.context.404.button") })] }));
};
export default NotFound;
//# sourceMappingURL=NotFound.js.map